import { API_SERVICES } from "@packages/api/types";
import store from "@packages/store";

export default {
    API_SERVICE: API_SERVICES.MARKETING,

    url(path = "") {
        return `${this.API_SERVICE}${this.apiUrl}${path}`;
    },

    userUrl({ userId, path = "" } = {}) {
        const userUrl = userId ? `/user/${userId}` : this.USER_URL();

        return `${this.API_SERVICE}${userUrl}${this.apiUrl}${path}`;
    },

    adminUrl(path = "") {
        return `${this.API_SERVICE}${this.urlAdmin}${path}`;
    },

    USER_URL() {
        const user = store.state.users.user || store.state.users.admin;

        if (!user || !user.id) throw Error("User not logged in");

        return `/user/${user.id}`;
    }
};
